import { useQueryLoading } from '@vue/apollo-composable';
import { getClickableLink } from '~/functions/helpers';
import { useBasicInfoForCompanyQuery, useGetAccountQuery } from '~/types/types';
export default defineComponent({
  setup: function setup() {
    var route = useRoute();
    var _useBasicInfoForCompa = useBasicInfoForCompanyQuery({
        ventureId: route.params.venture
      }, {
        fetchPolicy: 'cache-and-network'
      }),
      result = _useBasicInfoForCompa.result;
    var companyInfo = computed(function () {
      var _result$value$basicIn, _result$value;
      return (_result$value$basicIn = (_result$value = result.value) === null || _result$value === void 0 ? void 0 : _result$value.basicInfoForCompany) !== null && _result$value$basicIn !== void 0 ? _result$value$basicIn : null;
    });
    var _useGetAccountQuery = useGetAccountQuery({
        id: route.params.venture
      }),
      accountResult = _useGetAccountQuery.result;
    var account = computed(function () {
      var _accountResult$value$, _accountResult$value;
      return (_accountResult$value$ = (_accountResult$value = accountResult.value) === null || _accountResult$value === void 0 ? void 0 : _accountResult$value.getAccount) !== null && _accountResult$value$ !== void 0 ? _accountResult$value$ : {
        csrdRequirement: {}
      };
    });
    var esgActionsActive = computed(function () {
      return account.value.esgActionsActive === true;
    });
    var loading = useQueryLoading();
    var _useNuxtApp = useNuxtApp(),
      $i18n = _useNuxtApp.$i18n;
    var sections = computed(function () {
      var additionalContextInformationKeys = [{
        label: 'businessModel',
        title: $i18n.t('companyInfo.businessModel')
      }, {
        label: 'incomeStream',
        title: $i18n.t('companyInfo.incomeStream')
      }, {
        label: 'products',
        title: $i18n.t('companyInfo.products')
      }, {
        label: 'primaryIndustry',
        title: $i18n.t('companyInfo.primaryIndustry')
      }, {
        label: 'industries',
        title: $i18n.t('companyInfo.industries')
      }, {
        label: 'customerGroupOptions',
        title: $i18n.t('companyInfo.customerGroupOptions')
      }];
      if (esgActionsActive.value) {
        additionalContextInformationKeys.push({
          label: 'csrd.title',
          title: $i18n.t('companyInfo.csrd.title')
        });
      }
      return [{
        label: $i18n.t('companyInfo.basicInformation'),
        keys: [{
          label: 'pitchLine',
          title: $i18n.t('companyInfo.pitchline')
        }, {
          label: 'legalEntity',
          title: $i18n.t('companyInfo.legalEntity')
        }, {
          label: 'foundingYear',
          title: $i18n.t('companyInfo.foundingYear')
        }, {
          label: 'founders',
          title: $i18n.t('companyInfo.founders')
        }, {
          label: 'commercialRegisterNumber',
          title: $i18n.t('companyInfo.commercialRegisterNumber')
        }, {
          label: 'headquarter',
          title: $i18n.t('companyInfo.headquarter')
        }, {
          label: 'postcode',
          title: $i18n.t('companyInfo.postcode')
        }, {
          label: 'country',
          title: $i18n.t('companyInfo.country')
        }, {
          label: 'employeeHeadcount',
          title: $i18n.t('companyInfo.employeeHeadcount')
        }, {
          label: 'turnover',
          title: $i18n.t('companyInfo.turnover')
        }, {
          label: 'companyValuation',
          title: $i18n.t('companyInfo.valuation')
        }, {
          label: 'fundingStage',
          title: $i18n.t('companyInfo.fundingStage')
        }]
      }, {
        label: $i18n.t('companyInfo.additionalContextInformation'),
        keys: additionalContextInformationKeys
      }];
    });
    var ventureCompanyEdit = computed(function () {
      var _companyInfo$value;
      return {
        name: 'venture-company-edit-questionnaire',
        params: {
          questionnaire: (_companyInfo$value = companyInfo.value) === null || _companyInfo$value === void 0 ? void 0 : _companyInfo$value.questionnaireId
        }
      };
    });
    return {
      companyInfo: companyInfo,
      loading: loading,
      account: account,
      esgActionsActive: esgActionsActive,
      sections: sections,
      ventureCompanyEdit: ventureCompanyEdit,
      getClickableLink: getClickableLink
    };
  }
});